import { Editor } from '@ckeditor/ckeditor5-core/src/editor';
import debounce from 'lodash/debounce';
import React, { useEffect, useRef } from 'react';

export const useContentClick = (
  elRef: React.RefObject<HTMLDivElement>,
  selector: string,
  handler: (e?: any) => void,
  everyClickhandler: (e?: any) => void,
  editor: Editor,
): void => {
  type Fn = (e: Event) => void;
  const savedHandler = useRef<Fn>(() => null);
  const clickHandler = useRef<Fn>(() => null);

  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(() => {
    clickHandler.current = everyClickhandler;
  }, [everyClickhandler]);

  useEffect(() => {
    const everyEventListner = debounce(
      (event) => {
        clickHandler.current(event);
        if (event.target.matches(selector)) {
          savedHandler.current(event);
        }
      },
      200,
      {
        leading: true,
        trailing: false,
      },
    );
    const wrapperEl = elRef?.current;

    wrapperEl?.addEventListener('mouseup', everyEventListner);
    wrapperEl?.addEventListener('keydown', everyEventListner);

    return () => {
      wrapperEl?.removeEventListener('mouseup', everyEventListner);
      wrapperEl?.removeEventListener('keydown', everyEventListner);
    };
  }, [elRef, selector, editor]);
};
